import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Businessgamepotential() {
  return (
    <section
      className="business_game_potential p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-2 order-md-1 mt-4 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/web3-game/business_game.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={740}
              height={518}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-1 order-md-2"
          >
            <h2>
              Business Potential of <span>Web3 Game Development</span>
            </h2>
            <p>
              Web3 games have seen more than $2.4 billion USD investments in the
              past 2 years. These play-to-earn decentralized games, in their
              simplest forms, are decentralized apps powered by Blockchain
              technology. While the backend technology is innovative, these
              games also have evolving monetization strategies that present
              strong business cases for gaming companies.
            </p>
            <p>
              As a Web3 game development company, we have seen players engaging
              with Web3 games for professional gaming – and so, these NFT-based,
              play-to-earn and crypto games are not a luxury but offer the
              incentives of owning in-game assets.  We already have a case study
              for a successful NFT game, Ether Legends, but let’s talk about
              ZedRun and CryptoKitties. These games have reported annual revenue
              in billions and they are not slowing down anytime soon.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Businessgamepotential;
